import QuantityControl from "./QuantityControl";
import { Button } from 'primereact/button';
import { Image } from 'primereact/image';

const CartItem = ({
    item,
    lineKey,
    currencyFormatter,
    onDecreaseQty = () => {},
    onIncreaseQty = () => {},
    onChangeQty = () => {},
    isUpdatingQty = false,
    onRemove = () => {},
}) => (
    <article className="cart-item">
        <Image src={item.image} alt={item.name} />
        <div className="cart-item-content">
            <h3>{item.name}</h3>
            <span className="cart-item-variant">SKU: {item.code}</span>
            <span className="cart-item-warehouse">Sucursal: { item.warehouse || "SIN_ALMACEN"}</span>
            <QuantityControl
                value={item.quantity}
                disabled={isUpdatingQty}
                onDecrease={() => onDecreaseQty(lineKey, item.quantity)}
                onIncrease={() => onIncreaseQty(lineKey, item.quantity)}
                onChange={(nextQty) => onChangeQty(lineKey, nextQty, item.quantity)}
            />
        </div>
        <div className="cart-item-price">
            <strong>{currencyFormatter.format((item.price || 0) * Number(item.quantity || 0))}</strong>
            <Button 
                onClick={() => onRemove(lineKey)} disabled={isUpdatingQty}
                icon="pi pi-trash"
                severity="danger"
                text
            />
        </div>
    </article>
);

export default CartItem;
